<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator />
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
            <div>
              <el-row>
                <el-col>
                  <span class="cs-title">试听课信息</span>
                </el-col>
              </el-row>
              <freeTrialCourseList ref="freeTrialCourseList" @view="onView" />
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "freeTrialList",
  components: {
    navigator: () => import("@/components/navigator"),
    freeTrialCourseList: () =>
      import("@/components/addCollectFees/freeTrialCourseList"),
  },
  methods: {
    onView(enrollmentType, accountId) {},
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/page/addCollectFees/freeTrialList.vue